module.exports = __webpack_public_path__ + "static/media/full-screen.37b8e3e2.svg";